import { styled } from '@mui/material';
import Button, { ButtonProps } from 'components/Button';
import React from 'react';

const ButtonAsText: React.FC<ButtonProps> = styled(Button)(({ theme }) => ({
  padding: 0,
  textDecoration: 'underline',
  fontWeight: 'normal',
  border: 'none',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  color: theme.palette.text.rootColor,
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

export default ButtonAsText;
